import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SettingContainer } from 'z3k-settings/components/material-utils/settings-card';
import { BoilerList } from './ui/boiler-list';
import { HeatingList } from './ui/heating-list';
import { DhwList } from './ui/dhw-list';
import { IoExtensionsList } from './ui/io-extensions-list';
import { unpack_validation } from 'z3k-parser/validation/types';
import { SelectOutsideSensor } from 'z3k-settings/components/heating-circuits/select-outside';
export function ClimaticConfiguration() {
    return (_jsxs(SettingContainer, { sx: { px: 2, pb: 1 }, children: [_jsx(BoilerList, {}), _jsx(HeatingList, {}), _jsx(IoExtensionsList, {}), _jsx(SelectOutsideSensor, { like_card: true }), _jsx(DhwList, {})] }));
}
ClimaticConfiguration.isWarning = () => false;
ClimaticConfiguration.isError = (validation_result) => {
    const heating_circuits_validation = unpack_validation(validation_result, 'heating_circuits');
    return (heating_circuits_validation instanceof Array &&
        heating_circuits_validation.some((item, index) => unpack_validation(heating_circuits_validation, index, 'name')));
};
ClimaticConfiguration.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_service_view && is_climatic;
};
